import type { Setup } from "features/setups/types";
import { BaseSetupValue, type StringValue, type ISetupValue } from "../types";

export class StringSetupValue extends BaseSetupValue<StringValue> implements ISetupValue<StringValue> {
    public deserialize(setupValue: Setup<string>['setupValue']): StringValue {
       return String(setupValue);
    }

    public serialize() {
        return this.value;
    }
}
